import React from "react";
import { useState } from "react";
import _ from "lodash"

function useImportCsv() {
  const [importFiles, setImportFiles] = useState([]);

  const onChangeFile = (e) => {
    const file = e.target.files[0];
    const fileReader = new FileReader();
    if (file) {
      fileReader.onload = function (event) {
        const text = String(event.target.result);
        const csvHeader = text.slice(0, text.indexOf("\n")).split(",");
        const csvRows = text.slice(text.indexOf("\n")).split("\n");
        const rows = csvRows.map((row) => {
          const values = row.split(",");
          const obj = csvHeader.reduce((acc, header, index) => {
            const cleanHeader = _.trim(header).replace(/"/g, "");
            const cleanValue = _.trim(values[index]).replace(/"/g, "");
            acc[cleanHeader] = cleanValue
            return acc;
          }, {});
          return obj;
        });
        setImportFiles(rows);
      };
      fileReader.readAsText(file);
    }
  };

  const onClickImportCsv = () => {
    const doc = document.createElement("input");
    doc.type = "file";
    doc.accept = ".csv";
    doc.onchange = onChangeFile;
    doc.click();
  };

  return {
    onClickImportCsv,
    importFiles,
  };
}

export default useImportCsv;
